import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  { q: "Is Loan81 a bank or a lender?", a: "No. Loan81 is an independent loan comparison and advisory platform. We help you compare offers from RBI-registered banks and NBFCs. Loans are disbursed directly by the chosen lender." },
  { q: "Does using Loan81 cost anything?", a: "Never. There's no fee or charge to compare loans or get advice from us. We're paid a referral fee by lenders only when your loan is successfully disbursed." },
  { q: "Which credit score do banks look at?", a: "Most Indian lenders use your CIBIL score. A score of 750+ typically unlocks the best interest rates. Loan81 helps even applicants with 650–700 scores by matching them with lenders that accept lower scores." },
  { q: "How fast will my loan be disbursed?", a: "Digitally approved personal loans are typically disbursed within 24 hours after all documents are verified. Some lenders like Bajaj Finserv and IDFC First offer same-day disbursal for pre-approved customers." },
  { q: "What documents do I need?", a: "PAN card, Aadhaar, last 3 months' salary slips (for salaried) or ITR + bank statements (for self-employed), and passport-size photo. Digital KYC eliminates most paperwork." },
  { q: "Will comparing loans hurt my credit score?", a: "No. Loan81 uses 'soft-pull' inquiries when comparing which don't affect your score. Only when you formally apply with a chosen lender, a 'hard' inquiry is made — and that's standard." },
  { q: "Can I foreclose or prepay?", a: "Most lenders allow prepayment after 6-12 EMIs. Some like IDFC First offer zero foreclosure charges. Loan81 shows this info per lender before you apply." },
];

export const FAQ = () => (
  <section id="faq" className="py-20 sm:py-24 bg-white">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 mb-3">FAQ</div>
        <h2 className="font-display text-3xl sm:text-4xl tracking-tight font-medium text-slate-900">
          The questions everyone asks (and answers we don't hide).
        </h2>
      </div>

      <Accordion type="single" collapsible className="mt-10 border-t border-slate-200" data-testid="faq-accordion">
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="border-b border-slate-200">
            <AccordionTrigger data-testid={`faq-q-${i}`} className="text-left text-slate-900 font-display font-medium text-base sm:text-lg py-5 hover:no-underline">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-slate-600 text-sm leading-relaxed pb-5">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
